export enum MenuMutationTypes {
  UPDATE_URL = "UPDATE_URL",
  SET_OPEN_DROPDOWN_CREATE = "SET_OPEN_DROPDOWN_CREATE",
  SET_OPEN_DROPDOWN_OPTIONS = "SET_OPEN_DROPDOWN_OPTIONS",
}
